var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3774 4612",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2708 4211l685-720h-685v720zm360-3865c0 63-51 115-115 115-63 0-115-51-115-115V230H229v3462h113c63 0 115 51 115 115 0 63-51 115-115 115H206c-57 0-108-23-145-60s-60-89-60-145V208c0-57 23-108 60-145S150 3 206 3h2657c56 0 108 23 145 60s60 88 60 145v140zm706 3053c0 52-35 97-83 110L2682 4570c-21 26-53 42-88 42H912c-57 0-108-23-145-60s-60-88-60-145V898c0-57 23-108 60-145s89-60 145-60h2657c56 0 108 23 145 60s60 88 60 145v2501zm-229-137V922H936v3462h1543V3377c0-63 51-115 115-115h951z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLine);
export default __webpack_public_path__ + "static/media/copy-line.c4a61f1757151fb869b74942fd9253b1.svg";
export { ForwardRef as ReactComponent };